// extracted by mini-css-extract-plugin
module.exports = {"uikit-plain-text":"uikit-plain-text__IgVqw"};